import './style.scss'
import { ChangeCompanyTypeModal } from './Components/ChangeCompanyTypeModal'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { thunkGetTaxAuthority } from 'features/System/systemSlice'

function SystemNotifycationModal() {
  // const { title, describeText, icon, ...restProps } = props
  const [isShow, setIsShow] = useState(true)
  const { company } = useSelector((state) => state?.system)
  const dispatch = useDispatch()
  useEffect(() => {
    if (company.provinceId) {
      dispatch(
        thunkGetTaxAuthority({
          provinceId: company.provinceId,
        }),
      )
    }
  }, [company, company.provinceId, dispatch])
  // return <></> // mặc định không hiển thị modal
  return (
    <ChangeCompanyTypeModal
      show={isShow && company?.isUpdated == false}
      // show={isShow}
      setShow={setIsShow}
      company={company}
    />
  )
}

export default SystemNotifycationModal
